import { editClusterConfig, getClusterConfig } from './cluster.api';

import { createReducer, INITIAL_STATE } from '../../../shared/redux';
import { LOAD_STATE } from '../../../shared/axios';
import { ClusterData } from './cluster.types';

export const types = {
    GET_CLUSTERS_REQUEST_CALLED: '@dashboard/cluster/GET_CLUSTERS_REQUEST_CALLED',
    GET_CLUSTERS_REQUEST_SUCCEEDED: '@dashboard/cluster/GET_CLUSTERS_REQUEST_SUCCEEDED',
    GET_CLUSTERS_REQUEST_FAILED: '@dashboard/cluster/GET_CLUSTERS_REQUEST_FAILED',
    EDIT_CLUSTER_REQUEST_CALLED: '@dashboard/cluster/EDIT_CLUSTER_REQUEST_CALLED',
    EDIT_CLUSTER_REQUEST_SUCCEEDED: '@dashboard/cluster/EDIT_CLUSTER_REQUEST_SUCCEEDED',
    EDIT_CLUSTER_REQUEST_FAILED: '@dashboard/cluster/EDIT_CLUSTER_REQUEST_FAILED',
};

export const getClusters = ({ tagGroupId }) => ({
    type: types.GET_CLUSTERS_REQUEST_CALLED,
    actionTypes: {
        success: types.GET_CLUSTERS_REQUEST_SUCCEEDED,
        fail: types.GET_CLUSTERS_REQUEST_FAILED,
    },
    config: getClusterConfig({ tagGroupId }),
});

export const editCluster = ({
    cluster,
    id,
    name,
    statusBudgetManager,
    statusBidManager,
    monthlyBudget,
    tagGroup,
    changeType,
}) => ({
    type: types.EDIT_CLUSTER_REQUEST_CALLED,
    actionTypes: {
        success: types.EDIT_CLUSTER_REQUEST_SUCCEEDED,
        fail: types.EDIT_CLUSTER_REQUEST_FAILED,
    },
    config: editClusterConfig({
        id,
        name,
        statusBudgetManager,
        statusBidManager,
        monthlyBudget,
        tagGroup,
        changeType,
    }),
    payload: {
        id,
        name,
        statusBudgetManager,
        statusBidManager,
        monthlyBudget,
        tagGroup,
        changeType,
        previousCluster: cluster,
    },
});

const initialState: ClusterData = {
    clusterCollection: {
        loadState: LOAD_STATE.LOADING,
        data: [],
        error: null,
    },
    clusterEdited: {
        loadState: LOAD_STATE.LOADING,
        data: null,
        error: null,
    },
};

export const clusterReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [types.GET_CLUSTERS_REQUEST_CALLED]: state => ({
        ...state,
        clusterCollection: {
            ...state.clusterCollection,
            loadState: LOAD_STATE.LOADING,
        },
    }),
    [types.GET_CLUSTERS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        clusterCollection: {
            data: action.payload.data,
            loadState: LOAD_STATE.SUCCESS,
            error: null,
        },
    }),
    [types.GET_CLUSTERS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        clusterCollection: {
            ...state.clusterCollection,
            loadState: LOAD_STATE.FAIL,
            error: action.payload,
        },
    }),
    [types.EDIT_CLUSTER_REQUEST_CALLED]: (state, action) => ({
        ...state,
        clusterEdited: {
            error: null,
            data: state.clusterCollection.data.find(
                cluster => (cluster.id === action.payload.id),
            ),
            loadState: LOAD_STATE.LOADING,
        },
    }),
    [types.EDIT_CLUSTER_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        clusterCollection: {
            data: state.clusterCollection.data.map(
                cluster => (cluster.id === action.payload.data.id ? action.payload.data : cluster),
            ),
            loadState: LOAD_STATE.SUCCESS,
            error: null,
        },
        clusterEdited: {
            data: action.payload.data,
            loadState: LOAD_STATE.SUCCESS,
            error: null,
        },
    }),
    [types.EDIT_CLUSTER_REQUEST_FAILED]: (state, action) => ({
        ...state,
        clusterEdited: {
            ...state.clusterEdited,
            loadState: LOAD_STATE.FAIL,
            error: action.payload,
        },
    }),
});
